export default __webpack_public_path__ + "static/media/close.3344ef29.svg";